import styled from 'styled-components';

export const ZoomIcon = styled.img`
  cursor: pointer;
  margin: 3px;
`;
